import { render, staticRenderFns } from "./MmfTableNoBtn.vue?vue&type=template&id=8c3425be&"
import script from "./MmfTableNoBtn.vue?vue&type=script&lang=js&"
export * from "./MmfTableNoBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports